"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DateContext_1 = require("./DateContext");
/**
 * A provider of common Date info to the app that needs to be directly
 * shared to components
 *
 * When components use the DateProvider they will be able to work inside
 * or outside of the provider since wrapping the component in a provider
 * is just overriding the defaultContext.
 *
 * For Example `DateTime`:
 *
 * This works outside of the DateProvider and falls back to browser timezone
 * ```
 * <DateTime />
 * ```
 *
 * However to get the correct user profile timezone we must wrap it
 * inside of an DateProvider
 *
 * ```
 * <DateProvider timezone="EST">
 *  <DateTime />
 * </DateProvider>
 * ```
 *
 * This is useful because we can:
 *
 * 1. Create / test the components independent of the data source here.
 *
 * 2. Connect them to data sources based on the environment of the app.
 * <br />- `web` will connect DateProvider to the redux store
 * <br />- `web-ssr` will use graphql queries in the DateProvider
 */
const DateProvider = (props) => {
    const { children } = props, innerDate = __rest(props, ["children"]);
    const outerDate = DateContext_1.useDate();
    const app = Object.assign(Object.assign({}, outerDate), innerDate);
    return children ? (react_1.default.createElement(DateContext_1.DateContext.Provider, { value: app }, react_1.default.Children.only(children))) : null;
};
exports.default = DateProvider;
